export default {
  SET_AP_DOCUMENTS(state, documents) {
    state.documents = documents
  },
  SET_AP_DOCUMENT(state, document) {
    state.document = document
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination
  },
  SET_STATS(state, stats) {
    state.stats = stats
  },
  SET_SYNC_STATUS(state, syncStatus) {
    state.syncStatus = syncStatus
  },
}

